export const SET_PREGNANT_WOMEN_DATA = 'SET_PREGNANT_WOMEN_DATA';
export const SET_CHILD_DATA = 'SET_CHILD_DATA';
export const SET_FAMILY_PLANNING_DATA = 'SET_FAMILY_PLANNING_DATA'
export const SET_HEALTH_PROVIDERS_DATA = 'SET_HEALTH_PROVIDERS_DATA'
export const SET_HEALTH_FACILITIES_DATA = 'SET_HEALTH_FACILITIES_DATA'
export const SET_HIERARCHY_FILTER_DASHBOARD = 'SET_HIERARCHY_FILTER_DASHBOARD';
export interface setPregnantWomenData {
  type: typeof SET_PREGNANT_WOMEN_DATA;
  payload: any;
}

export interface setChildDashboardData {
  type: typeof SET_CHILD_DATA;
  payload: any;
}

export interface setFamilyPlanningDashboardData {
  type: typeof SET_FAMILY_PLANNING_DATA;
  payload: any;
}

export interface setHeathProvidersDashboardData {
  type: typeof SET_HEALTH_PROVIDERS_DATA;
  payload: any;
}

export interface setHeathFacilitiesDashboardData {
  type: typeof SET_HEALTH_FACILITIES_DATA;
  payload: any;
}
export interface setHierarchyFiltersDashboard {
  type: typeof SET_HIERARCHY_FILTER_DASHBOARD;
  data:any;
}
export type facilityDashboardType =
  | setPregnantWomenData
  | setChildDashboardData
  | setFamilyPlanningDashboardData
  | setHeathProvidersDashboardData
  | setHeathFacilitiesDashboardData
  | setHierarchyFiltersDashboard;
